import PropTypes from 'prop-types';
import React from 'react'


export default class extends React.Component {
    static propTypes = {
		onChange: PropTypes.func,
		defaultValue: PropTypes.string,
		className: PropTypes.string,
		placeholder: PropTypes.string,
		maxLength: PropTypes.string.isRequired,
	};

    state = {
        lengthRemaining: this.props.maxLength
    };

    componentDidMount() {
		this.updateLength()
	}

    change = (e) => {
		this.updateLength(e)
		if( !!this.props.onChange ) this.props.onChange(e)
	};

    updateLength = (e) => {

		let val = this.refs.input.value.length,
			maxLength = this.props.maxLength;

		this.setState({
			lengthRemaining: val >= maxLength ? 0 : maxLength - val
		})

	};

    render() {

		let inputProps = { ...this.props, onChange: this.change, ref: "input" };
		if( !('type' in inputProps) ) inputProps.type = 'text';
		
		return (

			<div className="input-group">
				<input {...inputProps} />
				<span className={"input-group-addon " + (this.state.lengthRemaining > 0 ? "text-mid-success" : "text-mid-danger")}>{this.state.lengthRemaining}</span>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/TextLength.js